import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function TestimonialThree() {
  const settings = {
    dots: false,
    arrow: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    margin: 30,
  };

  const TestimonilContent = [
    {
      desc: ` Dulu saya hanya jualan batik di pasar lokal, sekarang dengan platform ini, jangkauan pasar saya meluas ke seluruh Indonesia bahkan mancanegara.`,
      reviewerName: "Siti Aminah",
      designation: "Pedagang Batik",
    },
    {
      desc: `Saya butuh tempat yang lebih besar tapi terkendala biaya. Berkat gotong-royong, saya bisa mendapatkan ruang usaha yang terjangkau dan strategis.`,
      reviewerName: "Budi Santoso",
      designation: "Pemilik Bengkel Motor",
    },
    {
      desc: `Platform ini membantu saya terhubung dengan mentor dan investor yang mendukung pengembangan usaha saya.`,
      reviewerName: "Lina Marlina",
      designation: "Pengusaha Muda",
    },
    {
      desc: `Saya dibantu dalam pelatihan digital marketing yang sangat berguna untuk mengembangkan usaha saya secara online.`,
      reviewerName: "Andi Wijaya",
      designation: "Pengrajin Kerajinan Tangan",
    }
  ];

  return (
    <Slider {...settings}>
      {TestimonilContent.map((val, i) => (
        <div
          className="item"
          key={i}
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay="100"
        >
          <p>{val.desc}</p>
          <h6 className="name">{val.reviewerName}</h6>
          <span className="desig">{val.designation}</span>
        </div>
      ))}
    </Slider>
  );
}
